import { message } from 'antd'
import mapValues from 'lodash/mapValues'
import { useCallback } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import api from '../../api'
import { toPath } from '../../routes'
import { PageHeader } from '../Common'
import MissedTransmissionsForm from './Form'

export default function NewMissedTransmission() {
  const navigate = useNavigate()
  const { id: cycleId } = useParams()

  const onSubmit = useCallback(
    async ({ comment, preAuthorizationId }, { setErrors }) => {
      try {
        const missedTransmission = await api.missedTransmissions.create(
          preAuthorizationId,
          { comment },
        )
        message.success('Missed Transmission successfully created')
        navigate(
          toPath.missedTransmissions.missedTransmission({
            id: missedTransmission.id,
          }),
          { replace: true },
        )
      } catch (e) {
        if (e.response && e.response.errors) {
          setErrors(mapValues(e.response.errors, fieldErrors => fieldErrors[0]))
        } else {
          message.error(e.message)
        }
      }
    },
    [navigate],
  )

  return (
    <div>
      <PageHeader title="New Missed Transmission" onBack={() => navigate(-1)} />
      <MissedTransmissionsForm onSubmit={onSubmit} cycleId={cycleId} />
    </div>
  )
}
